import React from "react";

function HeroGrid() {
  return (
    <>
      {/* HERO GRID */}
      <div className="w-full bg-green-300">
        {/* Grif frame */}
        <div className="w-7/12 bg-red-300 mx-auto flex flex-row">
          {/* A */}
          <div className="bg-red-500 h-24 w-full">1</div>
          <div className="bg-yellow-500 h-24 w-full">
            <div className="flex flex-col">
              {/* B */}
              <div className="bg-gray-300 w-full h-12 flex-1">
                2
              </div>
              {/* C */}
              <div className="bg-blue h-12 w-full flex-1">
                3
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroGrid;
